import { IntegrationInstance, IntegrationProvider } from '@/types/integrations.ts';
import { isSharePointProvider } from '@/utils/providerKinds.ts';

const COMPACT_ID_PREFIX_LENGTH = 4;
const COMPACT_ID_SUFFIX_LENGTH = 4;

export const getIntegrationInstancePrimaryLabel = (
  provider?: IntegrationProvider,
  instance?: IntegrationInstance,
): string => {
  if (instance) {
    return instance.name || instance.id || provider?.display_name || '';
  }
  return provider?.display_name || '';
};

export const getCompactTenantId = (tenantId?: string | null): string | null => {
  if (!tenantId) return null;
  if (tenantId.length <= COMPACT_ID_PREFIX_LENGTH + COMPACT_ID_SUFFIX_LENGTH + 3) {
    return tenantId;
  }

  return `${tenantId.slice(0, COMPACT_ID_PREFIX_LENGTH)}...${tenantId.slice(-COMPACT_ID_SUFFIX_LENGTH)}`;
};

export const getFullTenantLabel = (tenantId?: string | null): string | null => {
  if (!tenantId) return null;
  return `Tenant: ${tenantId}`;
};

export const getIntegrationSelectLabel = (
  provider?: IntegrationProvider,
  instance?: IntegrationInstance,
): string => {
  if (!provider) return '';

  if (!instance || !instance.name) {
    return provider.display_name;
  }

  const primaryLabel = getIntegrationInstancePrimaryLabel(provider, instance);
  const baseLabel = `${provider.display_name} - ${primaryLabel}`;
  if (!isSharePointProvider(provider) || !instance.sharepoint_tenant_id) {
    return baseLabel;
  }

  const compactTenantId = getCompactTenantId(instance.sharepoint_tenant_id);
  return compactTenantId ? `${baseLabel} (tenant ${compactTenantId})` : baseLabel;
};
